import styled, { css } from "styled-components";
import { type LayoutProps, layout } from "styled-system";
import { getBreakpoint, getDirection } from "../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

// ----------------------------------------------------------------------
// Slider buttons
// ----------------------------------------------------------------------
const SliderButton = styled.button<{ show: boolean }>`
    display: none;
    position: absolute;
    top: 50%;
    width: 35px;
    height: 32px;
    margin-top: -16px;
    padding: 0;
    text-align: center;
    color: ${theme.colors.lightest};
    background: ${theme.colors.grey4};
    border: none;
    transition:
        opacity 0.24s,
        visibility 0.24s;
    /* Added important because couldn't figure out how to handle the hover opacity and the button opacity. Sorry :( */
    opacity: ${({ show }) => (show ? 0.7 : 0)} !important;
    visibility: ${({ show }) => (show ? "inherit" : "hidden")};
    z-index: 10;
    span {
        position: absolute;
        top: 50%;
        ${getDirection("left")}: 50%;
        color: ${theme.colors.lightest};
        transform: translate(-50%, -50%);
    }
    &:hover {
        opacity: ${({ show }) => (show ? 1 : 0)};
    }
    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const SliderLeft = styled(SliderButton)`
    ${getDirection("left")}: ${theme.space[3]}px;
`;

export const SliderRight = styled(SliderButton)`
    ${getDirection("right")}: ${theme.space[3]}px;
`;

export const Slider = styled.div`
    position: relative;
    margin-bottom: ${theme.space[2]}px;
    overflow: hidden;
`;

export const ImageWrapper = styled.div`
    width: 100%;
`;
export const Image = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
`;

export const SliderViewport = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    background: ${theme.colors.grey1};
    overflow: hidden;
    &::after {
        display: block;
        padding-bottom: 100%;
        content: "";
    }
`;

type TrackType = { width?: number; position: string; left: number; enableTransition: boolean };
export const Track = styled.div.attrs<TrackType>((props) => ({ style: { transform: `translateX(${props.left}px)` } }))<
    TrackType & LayoutProps
>`
    display: flex;
    position: ${(props) => props.position};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    flex-direction: row;
    height: 100%;
    z-index: 3;
    ${layout};
    ${(props) =>
        props.enableTransition &&
        css`
            transition:
                opacity 0.3s,
                transform 0.5s;
        `};
`;

export const SliderIndex = styled.div`
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 4;
`;

export const SliderBottom = styled.div`
    display: flex;
    position: absolute;
    bottom: 0;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 16px;
    z-index: 4;
`;
